import BasicResource from '@/api/resource';

class TrafficFilteringResource extends BasicResource {
    constructor () {
        super('traffic-filters');
    }
}

export default new TrafficFilteringResource;
